import Quill from "quill";
import { Fragmento } from "./fragmento.model";
import { Recurso } from "./recurso.model";
import { BancoRecursos } from "../util/banco-recursos.util";

export enum TipoLud {
    LUD_NORMAS = 1, LUD_INTERNET = 2, LUD_URL = 3, LUD_PALAVRA_CHAVE = 4
}

export class Lud {
    quill: Quill;
    idx: number;
    inicio: number;
    fim: number;
    
    tipo: TipoLud;
    
    url: string;
    fragmento: string;
    dispositivo: string;
    texto: string;
    idAto: number | null;
    
    static criarLudDoUrlEFragmento(url: string, fragmento: string): Lud {
        const lud = new Lud();
        lud.url = url;
        lud.fragmento = fragmento;
        return lud;
    }

    static criarLudDoDispositivo(dispositivo: Fragmento, recurso: Recurso, bancoRecursos: BancoRecursos): Lud {
        const lud = new Lud();
        lud.idAto = recurso.idAto;
        if (lud.idAto) {
            lud.url = bancoRecursos.obterUrlNormasExterno(recurso.idAto);
            lud.tipo = TipoLud.LUD_NORMAS;
        } else {
            lud.url = recurso.url;
            lud.tipo = TipoLud.LUD_INTERNET;
        }
        lud.fragmento = dispositivo.fragmento;
        lud.dispositivo = dispositivo.dispositivo;
        return lud;
    }
    
    static obterTipoLud(url: string): number {
        const lud = Lud.criarLudDoUrl(url);
        if (lud.tipo == TipoLud.LUD_URL) {
            return TipoLud.LUD_INTERNET;
        }
        return lud.tipo;
    }
    
    static criarLudDoUrl(url: string): Lud {
        const lud = new Lud();
        lud.url = url;
        lud.fragmento = '';
        if (url.indexOf('sijut') >= 0 && url.indexOf('.estaleiro.serpro.gov.br/') >= 0) {
            // https://h-sijut.np.estaleiro.serpro.gov.br/#/consulta/interna/
            // https://h-internet-sijut.np.estaleiro.serpro.gov.br/#/consulta/externa/
            // https://d-sijut.np.estaleiro.serpro.gov.br/#/consulta/interna/
            // https://d-sijut.np.estaleiro.serpro.gov.br/#/consulta/externa/
            let posicaoIdAto = this.indiceApos(url, '/consulta/interna/');
            if (posicaoIdAto) {
                const match = url.substring(posicaoIdAto).match(/^\d+/);
                lud.idAto = match ? parseInt(match[0]) : null;
            } else {
                posicaoIdAto = this.indiceApos(url, '/consulta/externa/');
                if (posicaoIdAto) {
                    const match = url.substring(posicaoIdAto).match(/^\d+/);
                    lud.idAto = match ? parseInt(match[0]) : null;
                }    
            }    
            if (posicaoIdAto && lud.idAto) {
                lud.tipo = TipoLud.LUD_NORMAS;
                const posicaoFragmento = url.substring(posicaoIdAto).indexOf('#') + posicaoIdAto;
                if (posicaoFragmento > posicaoIdAto) {
                    lud.url = url.substring(0, posicaoFragmento);
                    lud.fragmento = url.substring(posicaoFragmento + 1);
                }    
            }    
        } else if (url.indexOf('normas') >= 0 && url.indexOf('receita.fazenda') >= 0 && url.indexOf('sijut2consulta') >= 0) {
            // http://normas.receita.fazenda.gov.br/sijut2consulta/link.action?visao=anotado&idAto=
            // http://normasintranet.receita.fazenda/sijut2consulta-interno/link.action?ambienteInternet=false&visao=anotado&idAto=
            const posicaoIdAto = this.indiceApos(url, 'idAto=');
            if (posicaoIdAto) {
                const match = url.substring(posicaoIdAto).match(/^\d+/);
                lud.idAto = match ? parseInt(match[0]) : null;
            }    
            if (posicaoIdAto && lud.idAto) {
                lud.tipo = TipoLud.LUD_NORMAS;
                const posicaoFragmento = url.substring(posicaoIdAto).indexOf('#') + posicaoIdAto;
                if (posicaoFragmento > posicaoIdAto) {
                    lud.url = url.substring(0, posicaoFragmento);
                    lud.fragmento = url.substring(posicaoFragmento + 1);
                }    
            }    
        } else {
            // url (pode estar no banco de recursos)
            lud.tipo = TipoLud.LUD_URL;
            const posicaoFragmento = url.lastIndexOf('#');
            if (posicaoFragmento >= 0) {
                lud.url = url.substring(0, posicaoFragmento);
                lud.fragmento = url.substring(posicaoFragmento + 1);
            }    
        }    
        
        return lud;
    }

    private static indiceApos(url: string, trecho: string): number {
        const i = url.indexOf(trecho);
        return i >= 0 ? i + trecho.length : 0;
    }
}
